"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
const messages_1 = require("./messages");
const constants_1 = require("./constants");
const handler_1 = require("./handler");
function init(router, service) {
    router.registerMessage(messages_1.SendTxMsg);
    router.addHandler(constants_1.ROUTE, handler_1.getHandler(service));
}
exports.init = init;
//# sourceMappingURL=init.js.map